import { render, staticRenderFns } from "./text-field.vue?vue&type=template&id=71396ce4&scoped=true&"
import script from "./text-field.vue?vue&type=script&lang=js&"
export * from "./text-field.vue?vue&type=script&lang=js&"
import style0 from "./text-field.vue?vue&type=style&index=0&id=71396ce4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71396ce4",
  null
  
)

export default component.exports